var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurringPaymentXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2797_10717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57764 30.9372C1.57764 16.5019 13.2856 4.79395 27.7484 4.79395C32.1286 4.79395 36.2608 5.86833 39.8972 7.7967",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7829 1L40.8875 7.63912L34.0005 11.3306",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8916 30.937C53.8916 45.3723 42.1836 57.1078 27.7208 57.1078C22.4315 57.1078 17.5004 55.5376 13.3682 52.8378",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0386 60.0909L13 52.5702L20.6309 51",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4636 17.1336L13.8212 26.776C11.4651 29.132 11.4651 32.952 13.8212 35.308L23.4636 44.9504C25.8196 47.3064 29.6395 47.3064 31.9956 44.9504L41.638 35.308C43.994 32.952 43.994 29.132 41.638 26.776L31.9956 17.1336C29.6395 14.7776 25.8196 14.7776 23.4636 17.1336Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3491 28.2101V33.8574C22.3491 35.2724 23.4962 36.4194 24.9111 36.4194H30.5585C31.9734 36.4194 33.1205 35.2724 33.1205 33.8574V28.2101C33.1205 26.7951 31.9734 25.6481 30.5585 25.6481H24.9111C23.4962 25.6481 22.3491 26.7951 22.3491 28.2101Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2797_10717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.0689,
    height: 60,
    fill: "white",
    transform: "translate(0.200195 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringPaymentXl);
export default __webpack_public_path__ + "static/media/recurring_payment_XL.06d7a5478a59eb70fb515116cb05b50f.svg";
export { ForwardRef as ReactComponent };